import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  padding: 0 40px;

  @media (max-width: 743px) {
    padding: 0 15px;
  }
`;

export const DrawerItemsTitle = styled(Typography.Caption).attrs({
  $variant: '2',
})`
  position: sticky;
  z-index: 1;
  top: 0;
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 4px 0;
  background-color: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: 949px) {
    margin-left: 40px;
  }

  @media (max-width: 743px) {
    margin-left: 15px;
  }
`;
